import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@vio/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
const LogoWrapper = /*#__PURE__*/styled('div')({
  name: "LogoWrapper",
  class: "l1p7zp64",
  propsAsIs: false
});
const LabelWrapper = /*#__PURE__*/styled('div')({
  name: "LabelWrapper",
  class: "l1tv3ulq",
  propsAsIs: false
});
const SkeletonWrapper = /*#__PURE__*/styled('div')({
  name: "SkeletonWrapper",
  class: "s1ecnkjf",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  shouldShowFreeCancellationDate
}) => shouldShowFreeCancellationDate ? 'start' : 'center';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wukd39w",
  propsAsIs: false,
  vars: {
    "wukd39w-0": [_exp2()]
  }
});
const RightWrapper = /*#__PURE__*/styled('div')({
  name: "RightWrapper",
  class: "r1se83ho",
  propsAsIs: false
});
const RightInnerWrapper = /*#__PURE__*/styled('div')({
  name: "RightInnerWrapper",
  class: "rfuw7d",
  propsAsIs: false
});
type Props = Omit<OfferLayoutBaseProps, 'tagComponent'>;

// Added as part of 70766997-desktop-hotel-card-secondary-offers
export const SecondaryInlineLayout: React.FC<Props | OfferLayoutLoadingProps> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  roomLabelsComponent,
  ctaComponent,
  className,
  dataId,
  cashbackComponent,
  shouldShowFreeCancellationDate = false
}) => {
  if (isLoading) return <Wrapper>
        <SkeletonWrapper>
          <SkeletonLoader width={60} height={20} marginTop={0} />
          <SkeletonLoader width={91} height={20} marginTop={0} />
        </SkeletonWrapper>
        <SkeletonLoader width={24} height={20} marginTop={0} />
      </Wrapper>;
  return <Wrapper className={className} data-id={dataId} shouldShowFreeCancellationDate={shouldShowFreeCancellationDate}>
      <LogoWrapper>{providerLogoComponent}</LogoWrapper>
      <LabelWrapper>{roomLabelsComponent}</LabelWrapper>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {cashbackComponent}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>;
};

require("./SecondaryInlineLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SecondaryInlineLayout.tsx");